import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { DisplayTimingMap } from 'features/common/models';
import { EXPAND_ALL, MOBILE_ORDER_DISPLAY_ALL, MOBILE_ORDER_DISPLAY_ONLY_EDITED } from './constants';
import {
  EXPAND_SETTING,
  MOBILE_ORDER_DISPLAY_SETTING,
  StoreSettingDetailGetAllRequestPayload,
  StoreSettingDetailGetAllResponse,
} from './models';

export interface StoreSettingDetailState {
  loading: boolean;
  isReload: boolean;
  displayTimingSource?: DisplayTimingMap;
  expandAll?: EXPAND_SETTING;
  displayType: MOBILE_ORDER_DISPLAY_SETTING;
  data: StoreSettingDetailGetAllResponse;
  editedMenuBookIds: number[];
}

const initialState: StoreSettingDetailState = {
  loading: false,
  isReload: false,
  expandAll: EXPAND_ALL,
  displayType: MOBILE_ORDER_DISPLAY_ALL,
  data: {
    unassigned_menus: [],
    menu_books: [],
  },
  editedMenuBookIds: [],
};

const storeSettingDetailSlice = createSlice({
  name: 'store_setting_detail',
  initialState,
  reducers: {
    fetchData(state, action: PayloadAction<StoreSettingDetailGetAllRequestPayload>) {
      state.loading = true;
    },
    fetchDataSuccess(state, action: PayloadAction<StoreSettingDetailGetAllResponse>) {
      state.loading = false;
      state.displayType = MOBILE_ORDER_DISPLAY_ALL;
      state.data = action.payload;
      state.isReload = false;
    },
    fetchDataFailed(state) {
      state.loading = false;
    },
    setExpandAll(state, action: PayloadAction<EXPAND_SETTING | undefined>) {
      state.expandAll = action.payload;
    },
    toggleDisplayType(state) {
      state.displayType =
        state.displayType === MOBILE_ORDER_DISPLAY_ALL ? MOBILE_ORDER_DISPLAY_ONLY_EDITED : MOBILE_ORDER_DISPLAY_ALL;
    },
    addEditedMenuBookId(state, action: PayloadAction<number>) {
      if (!state.editedMenuBookIds.includes(action.payload)) {
        state.editedMenuBookIds.push(action.payload);
      }
    },
    setDisplayTimingSource(state, action: PayloadAction<DisplayTimingMap>) {
      state.displayTimingSource = action.payload;
    },
    reloadData(state) {
      state.isReload = true;
    },
    resetData(state) {
      state.displayType = MOBILE_ORDER_DISPLAY_ALL;
      state.isReload = false;
      state.data = {
        unassigned_menus: [],
        menu_books: [],
      };
    },
  },
});

// Actions
export const storeSettingDetailActions = storeSettingDetailSlice.actions;

// Selectors
export const selectStoreSettingDetailLoading = (state: RootState) => state.storeSettingDetail.loading;
export const selectStoreSettingDetailIsReload = (state: RootState) => state.storeSettingDetail.isReload;
export const selectStoreSettingDetailDisplayTimingSource = (state: RootState) =>
  state.storeSettingDetail.displayTimingSource;
export const selectStoreSettingDetailExpandAll = (state: RootState) => state.storeSettingDetail.expandAll;
export const selectStoreSettingDetailDisplayType = (state: RootState) => state.storeSettingDetail.displayType;
export const selectStoreSettingDetailData = (state: RootState) => state.storeSettingDetail.data;
export const selectStoreSettingEditedMenuBookIds = (state: RootState) => state.storeSettingDetail.editedMenuBookIds;

// Reducer
export const storeSettingDetailReducer = storeSettingDetailSlice.reducer;
